module.exports = __webpack_public_path__ + "img/JobInterview.8c309efe.svg";